(function() {
	'use strict';

	angular
		.module('video')
		.factory('VideoService', VideoService);

	/**
	 * Video Service
	 * @param {Service} $q $q
	 * @param {Object} $window $window
	 * @param {Service} CustomActionService CustomActionService
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @param {Constant} VIDEO_ASSETS VIDEO_ASSETS
	 * @returns {self} our service
	 * @ngInject
	 */
	function VideoService($q, $window, CustomActionService, Utilities, UtilsValidation, VIDEO_ASSETS) {
		var player,
			youtubeAssetsLoaded = false,
			isRealObject = UtilsValidation.isRealObject;
		var service = {
			createYTPlayer: createYTPlayer,
			getWindow: getWindow,
			getYTPlayer: getYTPlayer,
			loadYoutubeApi: loadYoutubeApi
		};

		return service;

		/**
		 * Get Window
		 * @public
		 * @returns {Object} $window
		 */
		function getWindow() {
			return $window;
		}

		/**
		 * Get Youtube player initialized
		 * @public
		 * @returns {Object} Youtube player
		 */
		function getYTPlayer() {
			return player;
		}

		/**
		 * Create Youtube Player
		 * @public
		 * @returns {undefined}
		 */
		function createYTPlayer() {
			var $win = service.getWindow();
			if (isRealObject($win.YT)) {
				player = new $win.YT.Player('embed-iframe');
			}
		}

		/**
		 * Load Youtube API
		 * @public
		 * @returns {Promise} Promise
		 */
		function loadYoutubeApi() {
			var $win = service.getWindow();

			if (youtubeAssetsLoaded) {
				service.createYTPlayer();
				return $q.resolve();
			}

			$win.onYouTubeIframeAPIReady = function() {
				youtubeAssetsLoaded = true;
				service.createYTPlayer();
				$win.onYouTubeIframeAPIReady = null;
			};

			return Utilities
				.addScriptToDocument('https://www.youtube.com/iframe_api', 'g-youtube', undefined, 1, undefined, {
					asPromise: true,
					disableReinsert: true
				});
		}
	}
})();